import { useField, useFormikContext } from 'formik';
import { memo } from 'react';
import { CommandGroup, CommandItem } from '@src/design-system/command';

export const Timezones = memo(
  ({ name, timezones }: { name: string; timezones: string[] }) => {
    const { setFieldValue } = useFormikContext();
    const [selectFieldProps] = useField(name);

    return (
      <CommandGroup>
        {timezones?.map((t) => {
          const isSelected = selectFieldProps.value === t;
          return (
            <CommandItem
              isSelected={isSelected}
              key={t}
              value={t}
              onSelect={() => {
                setFieldValue(name, t);
              }}
            >
              {t}
            </CommandItem>
          );
        })}
      </CommandGroup>
    );
  }
);
